import { render, staticRenderFns } from "./document-detail.vue?vue&type=template&id=0d95b6c0&scoped=true&"
import script from "./document-detail.vue?vue&type=script&lang=js&"
export * from "./document-detail.vue?vue&type=script&lang=js&"
import style0 from "./document-detail.vue?vue&type=style&index=0&id=0d95b6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95b6c0",
  null
  
)

component.options.__file = "document-detail.vue"
export default component.exports